export function valueAsNumber(value) {
  return typeof value === 'number' ? `${value}` : value ? value : ''
}



// WEBPACK FOOTER //
// ./src/lib/helpers/valueAsNumber.js